// src/utils/errors.ts — FINAL
export class FetchError extends Error {
    constructor(
        message: string,
        public url: string,
        public status?: number,
    ) {
        super(message);
    }
}
export class DecodeError extends Error {
    constructor(
        message: string,
        public id: string,
    ) {
        super(message);
    }
}
export class PlayError extends Error {
    constructor(
        message: string,
        public id: string,
    ) {
        super(message);
    }
}
